export default "__VITE_ASSET__Dmf9Kg5p__"